import { render, staticRenderFns } from "./AgiModal.vue?vue&type=template&id=07f20b24&scoped=true"
import script from "./AgiModal.vue?vue&type=script&lang=ts"
export * from "./AgiModal.vue?vue&type=script&lang=ts"
import style0 from "./AgiModal.vue?vue&type=style&index=0&id=07f20b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f20b24",
  null
  
)

export default component.exports